(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/createClass"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/createClass"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.createClass);
    global.util = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _createClass2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports.DirectiveClass = void 0;
  _exports.getWxErrMsg = getWxErrMsg;
  _exports.isIOS = isIOS;
  _createClass2 = _interopRequireDefault(_createClass2);

  function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  /**
   * 指令描述对象。
   * types for define directive in component.
   * wx: [{ name: 'share', option: {} }]
   */

  /**
   * 指令对象，对指令描述进行解析后的对象。
   * One directive is something that has name and options.
   * so the internal system can compile it and run commands base on
   * the directive.
   */
  var DirectiveClass = /*#__PURE__*/function () {
    function DirectiveClass(directive) {
      this.name = void 0;
      this.args = {};
      this.option = {};
      this.option = directive.option || {};

      var _this$parseArgsFromNa = this.parseArgsFromName_(directive.name),
          name = _this$parseArgsFromNa.name,
          args = _this$parseArgsFromNa.args; // share:disable:after3Seconds
      // share is directive name.
      // disable, after3Seconds is args


      this.name = name;
      this.args = args;
    }

    var _proto = DirectiveClass.prototype;

    _proto.parseArgsFromName_ = function parseArgsFromName_(name) {
      var args = {};
      var splits = name.split(":");
      var n = splits.shift() || "";

      for (var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;) {
        var i = _step.value;
        args[i] = true;
      }

      return {
        name: n,
        args: args
      };
    };

    (0, _createClass2["default"])(DirectiveClass, [{
      key: "argsCount",
      get: function get() {
        return Object.keys(this.args).length;
      }
    }]);
    return DirectiveClass;
  }();
  /**
   * Context needed by the directive processor.
   * @dependant DirectiveProcessorCallback
   */


  _exports.DirectiveClass = DirectiveClass;

  function isIOS() {
    var ua = navigator.userAgent;

    if (/\bwechatdevtools/i.test(ua)) {
      return false;
    }

    return ua.indexOf("iPhone") > 0 || ua.indexOf("iPad") > 0 || ua.indexOf("iPhone") > 0;
  }

  function getWxErrMsg(res) {
    if (res instanceof Error) {
      return res.message;
    }

    if (res && res.errMsg) {
      return res.errMsg;
    }

    return null;
  }
});
//# sourceMappingURL=util.js.map